


















































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ConfirmationPayload } from "../types";
import LoaderSvg from "@/modules/auth/components/LoaderSvg.vue";

const Auth = namespace("auth");

@Component({
  components: {
    loader: LoaderSvg,
  },
})
export default class Confirm extends Vue {
  @Auth.Action("confirmEmail") confirmEmail!: (
    payload: ConfirmationPayload
  ) => Promise<{}>;

  isEmailConfirmed = false;
  hasError = false;
  loading = true;

  beforeMount() {
    const userId = this.$route.query.userId as string;
    const encodedToken = this.$route.query.token as string;
    const token = decodeURI(encodedToken);

    //send post confirmation
    if (userId && token) {
      this.confirmEmail({
        userId,
        token,
      })
        .then(() => {
          this.loading = false;
          this.isEmailConfirmed = true;
        })
        .catch(() => {
          this.loading = false;
          this.hasError = true;
        });
    }
  }
}
